import React from "react";
import { Button, Table } from "react-bootstrap";
import { useLang } from "../../../../../../../language";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLink } from "@fortawesome/free-solid-svg-icons";
import { receiveFecha, receiveFechaFormat2 } from "../../../../../../../adapters/helpers";
import { useNavigate } from "react-router-dom";

export const Facturas = ({ idpedido, formInscripcion }: any) => {

    const Lang = useLang()
    
    const navigate = useNavigate()

    return (
        <>
            <h5 className='mb-3'>{Lang('FACTURAS')}</h5>

            <Table bordered responsive>
                <thead>
                    <tr>
                        <th>
                            <small>{Lang('FACTURA')}</small>
                        </th>
                        <th>
                            <small>{Lang('FECHA_FACTURA')}</small>
                        </th>
                        <th>
                            <small>{Lang('ESTADO')}</small>
                        </th>
                        {/* <th className='shrink-td text-nowrap'>{Lang('PUBLICAR_EN_WEB')}</th> */}
                        <th className='text-center'></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        formInscripcion.facturas?.map((item: any) => {
                            return (
                                <tr>
                                    <td>
                                        <small>{item.numerofactura || item.numeroproforma || ''}</small>
                                    </td>
                                    <td>
                                        <small>{receiveFechaFormat2(receiveFecha(item.fechafactura))}</small>
                                    </td>
                                    <td>
                                        <small>{item.estado}</small>
                                    </td>
                                    {/* <td className='text-center shrink-td'>
                                                        {item.publicaweb === 'false' ? 'No' : 'Si'}
                                                    </td> */}
                                    <td className='text-center text-nowrap' valign='middle'>
                                        <Button
                                            onClick={() => navigate(`/facturacion/facturas/${item.idfactura}`)}
                                            className="" size='sm'>

                                            <FontAwesomeIcon icon={faExternalLink} className='mx-1' />
                                        </Button>
                                    </td>
                                </tr>
                            )
                        })
                    }
                    {
                        formInscripcion.facturas?.length === 0 &&
                        <tr>
                            <td colSpan={20} className='text-center py-5'>{Lang('PARRAFO_NO_HAY_DATOS_PARA_MOSTRAR')}</td>
                        </tr>
                    }
                </tbody>
            </Table>

        </>
    );
};
